import { render, staticRenderFns } from "./WxPayQrCode.vue?vue&type=template&id=a2496448&scoped=true"
import script from "./WxPayQrCode.vue?vue&type=script&lang=js"
export * from "./WxPayQrCode.vue?vue&type=script&lang=js"
import style0 from "./WxPayQrCode.vue?vue&type=style&index=0&id=a2496448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2496448",
  null
  
)

export default component.exports